import React from 'react'
import * as UI from '@brewlogix/blx-ui'

import { useSearch } from '../../state/useSearch'
import LiveSearchResult from './LiveSearchResult'
import { CompositeSearchResult } from '../../types'
import LiveSearchNoResults from '../cards/LiveSearchNoResults'
import LiveSearchError from '../cards/LiveSearchError'
import classNames from 'classnames'
import StaticSearchResult from './StaticSearchResult'

const StaticSearchResults: React.FC = () => {
    const { searchTerm, isSearching, error, results, activeTab, searchIsReady, nextToken } =
        useSearch()
    const [searchResults, setSearchResults] = React.useState<CompositeSearchResult[]>([])
    const [noResults, setNoResults] = React.useState<boolean>(false)

    React.useEffect(() => {
        setSearchResults(results)
        setNoResults(searchIsReady && results?.length < 1)
    }, [results, activeTab, searchIsReady])

    return (
        <div
            className={classNames(
                'border-t-none mt-6 h-auto w-full overflow-hidden border-t-0 border-gray-50 transition-all duration-200 ease-in'
            )}
        >
            <div>
                <div
                    className={classNames(
                        'relative flex w-full flex-col items-start overflow-hidden rounded-t-lg border-px border-gray-100 bg-white',
                        isSearching && 'min-h-36'
                    )}
                >
                    <div
                        className={classNames(
                            'pointer-events-none absolute top-0 bottom-0 left-0 right-0 z-20 flex w-full flex-col justify-start bg-white bg-opacity-80 pt-16 text-center transition-all duration-200',
                            isSearching ? 'opacity-100' : 'opacity-0'
                        )}
                    >
                        <UI.Loading />
                    </div>

                    {searchResults?.map((item, index) => (
                        <StaticSearchResult item={item} key={`${index}-${item?.id}`} />
                    ))}

                    {searchTerm && noResults && <LiveSearchNoResults />}

                    {!searchTerm && (
                        <div className='p-6 text-medium'>
                            Search by brewery, location or brew name
                        </div>
                    )}

                    {error && <LiveSearchError />}
                </div>
            </div>
        </div>
    )
}

export default StaticSearchResults
